"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const Svg_1 = (0, tslib_1.__importDefault)(require("./Svg"));
const SvgAttachment = (_a) => {
    var { size = 24 } = _a, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (react_1.default.createElement(Svg_1.default, Object.assign({ fill: "currentColor", viewBox: "0 0 25 24", size: size }, props),
        react_1.default.createElement("path", { fill: "currentColor", d: "M22.604 3.455a6.96 6.96 0 00-9.846 0L2.38 13.832a5.128 5.128 0 007.252 7.252l8.429-8.431A3.293 3.293 0 1013.407 8l-5.19 5.184A1 1 0 009.633 14.6l5.189-5.191a1.294 1.294 0 011.829 1.83l-8.432 8.43a3.128 3.128 0 11-4.424-4.423L14.172 4.869a4.962 4.962 0 017.018 7.018l-7.783 7.783a1 1 0 101.414 1.414l7.783-7.784a6.96 6.96 0 000-9.846z" })));
};
exports.default = SvgAttachment;
//# sourceMappingURL=Attachment.js.map